import { useGetPromoBanners } from '@/api/promo-banner/promo-banner.hooks';
import { AddPromoBanner } from '@/components/promo-banner/AddPromoBanner';
import { PromoBannerCard } from '@/components/promo-banner/PromoBannerCard';
import { PromoBannerPreviewModal } from '@/components/promo-banner/PromoBannerPreviewModal';
import { ErrorScreen } from '@/components/ui/error-screen';
import { LoadingScreen } from '@/components/ui/loading-screen';
import { AppPageLayout } from '@/layouts/AppPageLayout';

export const PromoBannerPage = () => {
  const { banners, isError, isLoading } = useGetPromoBanners();

  if (isLoading) return <LoadingScreen />;
  if (isError || !banners) return <ErrorScreen />;

  const frBanners = banners.filter((b) => b.region === 'FR');
  const usBanners = banners.filter((b) => b.region === 'US');

  return (
    <AppPageLayout
      title="Bannières promotionnelles"
      description="Gestion des bannières promotionnelles"
    >
      <div className="flex flex-col gap-4 h-full">
        <div className="flex justify-end gap-2 shrink-0">
          <PromoBannerPreviewModal banners={banners} />
          <AddPromoBanner />
        </div>

        <div className="flex flex-col gap-6 overflow-y-auto pb-10">
          <div className="flex flex-col gap-4">
            <h2 className="text-lg font-semibold">🇫🇷 Mademoiselle Culotte</h2>
            <div className="flex flex-wrap gap-4">
              {frBanners.length === 0 && (
                <p className="text-zinc-400 text-sm">Aucune bannière</p>
              )}
              {frBanners.map((banner) => (
                <PromoBannerCard key={banner.id} {...banner} />
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <h2 className="text-lg font-semibold">🇺🇸 Orpair</h2>
            <div className="flex flex-wrap gap-4">
              {usBanners.length === 0 && (
                <p className="text-zinc-400 text-sm">Aucune bannière</p>
              )}
              {usBanners.map((banner) => (
                <PromoBannerCard key={banner.id} {...banner} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </AppPageLayout>
  );
};
